import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { hideMessage, showMessage } from 'app/store/fuse/messageSlice';
import { getUserData, logoutUser } from './store/userSlice';
import { checkLoginState } from './store/loginSlice';

class Auth extends Component {
	state = { waitAuthCheck: true };

	componentDidMount() {
		return Promise.all([this.authCheck()]).then(() => {
			this.setState({ waitAuthCheck: false });
		});
	}

	authCheck = () => {
		return new Promise(resolve => {
			Promise.resolve(this.props.checkLoginState()).then(() => resolve()).catch(() => resolve());
		});
	};

	render() {
		return this.state.waitAuthCheck ? <FuseSplashScreen /> : <>{this.props.children}</>;
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			logout: logoutUser,
			getUserData,
			checkLoginState,
			showMessage,
			hideMessage
		},
		dispatch
	);
}

export default connect(null, mapDispatchToProps)(Auth);
